import React from 'react';
import { Box } from '@mui/material';
import { SafeImageProps } from '../types';

const SafeImage: React.FC<SafeImageProps> = ({ src, alt, fallback, ...props }) => {
  const [imgSrc, setImgSrc] = React.useState(src);
  const [hasError, setHasError] = React.useState(false);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    // console.log('=== IMAGE ERROR ===');
    // console.log('Failed src:', imgSrc);
    // console.log('Error event:', e);
    // console.log('Fallback available:', !!fallback);
    // console.log('Has error already:', hasError);
    
    if (!hasError) {
      setHasError(true);
      if (fallback) {
        // console.log('Trying fallback:', fallback);
        setImgSrc(fallback);
      } else {
        // Use a placeholder as last resort
        const placeholder = `https://picsum.photos/seed/placeholder-${Math.random()}/400/300.jpg`;
        // console.log('Using placeholder:', placeholder);
        setImgSrc(placeholder);
      }
    }
  };

  const handleLoad = () => {
    // console.log('=== IMAGE LOADED SUCCESSFULLY ===');
    // console.log('Loaded src:', imgSrc);
    setHasError(false);
  };

  return (
    <Box
      component="img"
      src={imgSrc}
      alt={alt}
      onError={handleError}
      onLoad={handleLoad}
      loading="lazy"
      {...props}
      sx={{
        objectFit: 'cover',
        backgroundColor: hasError ? '#f5f5f5' : 'transparent',
        ...props.sx,
      }}
    />
  );
};

export default SafeImage;
